import React from 'react'
import {Stack, Typography} from '@mui/material'
import WbModal from '../../../common/WbModal'
import WbButton from '../../../common/WbButton'
import WbOutlineButton from '../../../common/WbOutlineButton'

const describe = reference => {
  const where = reference.ruleNumber
    ? `rule ${reference.ruleNumber}`
    : 'the "Otherwise" route'
  return reference.asDestination
    ? `${where} sends respondents here`
    : `${where} uses this question`
}

export default function ItemDeleteGuard({
  itemLabel,
  references,
  sectionLabel,
  onCancel,
  onConfirm,
}) {
  return (
    <WbModal
      title={<h3>Delete {itemLabel}?</h3>}
      onClose={onCancel}
      content={
        <Stack spacing={2} mt={2}>
          <Typography variant="body2">
            These skip-logic rules refer to it. After deleting, they are marked
            invalid and the survey cannot be published until they are fixed.
          </Typography>
          <ul>
            {references.map(reference => (
              <li
                key={`${reference.sectionKey}-${reference.ruleId ?? 'otherwise'}`}
              >
                {sectionLabel(reference.sectionKey)}: {describe(reference)}
              </li>
            ))}
          </ul>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <WbOutlineButton
              CustomOutlineButtonText="Cancel"
              onClick={onCancel}
            />
            <WbButton CustomButtonText="Delete anyway" onClick={onConfirm} />
          </Stack>
        </Stack>
      }
    />
  )
}
